import React from 'react'

const AutomationOptionsHomePod = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="43" height="52" viewBox="0 0 43 52" fill="none" className={className}>
    <path
      d="M41.3001 12.6199V40.2999C41.2974 43.1635 40.1587 45.909 38.1339 47.9338C36.1091 49.9586 33.3636 51.0973 30.5001 51.0999H12.3001C9.43653 51.0973 6.69104 49.9586 4.66622 47.9338C2.64141 45.909 1.5027 43.1635 1.50005 40.2999V12.6199C1.49377 10.6242 2.04212 8.66604 3.08393 6.96383C4.12573 5.26162 5.62002 3.88236 7.40005 2.97994C8.73746 2.30082 10.2022 1.90909 11.7001 1.82994L14.4401 1.68994C19.05 1.43994 23.6701 1.43994 28.2801 1.68994L31.0201 1.82994C32.5451 1.89793 34.0383 2.28996 35.4001 2.97994C37.1801 3.88236 38.6744 5.26162 39.7162 6.96383C40.758 8.66604 41.3063 10.6242 41.3001 12.6199V12.6199Z"
      stroke="black"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M35.4004 2.97994C32.4004 4.81994 27.2804 6.03994 21.4004 6.03994C15.5204 6.03994 10.4004 4.81994 7.40039 2.97994C8.7378 2.30082 10.2025 1.90909 11.7004 1.82994L14.4404 1.68994C19.0503 1.43994 23.6704 1.43994 28.2804 1.68994L31.0204 1.82994C32.5455 1.89793 34.0386 2.28996 35.4004 2.97994V2.97994Z"
      stroke="black"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
  </svg>
)

export default AutomationOptionsHomePod
